export function createSportsnewMembershipInvalidationScheduler({
  onInvalidate,
  delayMs = 250,
  maxWaitMs = 1_000,
  setTimer = setTimeout,
  clearTimer = clearTimeout,
} = {}) {
  if (typeof onInvalidate !== 'function') throw new TypeError('onInvalidate is required');
  let trailingTimer = null;
  let maxWaitTimer = null;

  const cancel = () => {
    if (trailingTimer != null) clearTimer(trailingTimer);
    if (maxWaitTimer != null) clearTimer(maxWaitTimer);
    trailingTimer = null;
    maxWaitTimer = null;
  };
  const flush = () => {
    cancel();
    onInvalidate();
  };
  const schedule = () => {
    if (maxWaitTimer == null) maxWaitTimer = setTimer(flush, maxWaitMs);
    if (trailingTimer != null) clearTimer(trailingTimer);
    trailingTimer = setTimer(flush, delayMs);
  };

  return Object.freeze({ schedule, flush, cancel });
}
